import React from "react";
import PropTypes from "prop-types";

import AlgoliaCardsPresenter from "presenters/AlgoliaCardsPresenter";
import FeaturedClips from "components/FeaturedClips";
import AlgoliaLoadingIndicator from "components/AlgoliaLoadingIndicator";

import SearchBox from "./components/SearchBox";

const AlgoliaFeaturedClips = ({ carousel, loading }) => {
  const query = carousel ? AlgoliaCardsPresenter.queryTerm(carousel) : "";
  const id = AlgoliaCardsPresenter.id(carousel);
  const loggerData = {
    contentfulId: id,
    query,
    component: "AlgoliaFeaturedClips",
  };

  return (
    <>
      <AlgoliaLoadingIndicator loading={loading} loggerData={loggerData}>
        <FeaturedClips loading />;
      </AlgoliaLoadingIndicator>
      <SearchBox defaultRefinement={query} carousel={carousel} loading={loading} />
    </>
  );
};

AlgoliaFeaturedClips.propTypes = {
  carousel: PropTypes.shape(),
  loading: PropTypes.bool,
};

export default AlgoliaFeaturedClips;
